/**
 * @file object.component.tsx
 * @description Компонент для отображения и работы с объектом системы в списке вложений с возможностью открытия формы
 * @author AI-Generated | Human-Reviewed
 * @created 2025-09-03
 * @updated 2025-09-10
 * @dependencies ['@consta/icons/IconKebab', '@consta/uikit/ContextMenu', '@consta/uikit/Text', '@components/icons/close-file-round/close-file-roind.icon', 'react', '@features/object-form', '@utils/data-helper', '@utils/form-object-helper', '@consta/icons/IconConnection', '@src/types']
 * @related-files ['src/components/ui/data/attachment-list/attachment-list.component.tsx', 'src/features/object-form/object-form.component.tsx']
 */

import { IconKebab } from '@consta/icons/IconKebab';
import { ContextMenu } from '@consta/uikit/ContextMenu';
import { Text } from '@consta/uikit/Text';
import { CloseFileRoundIcon } from '@components/icons/close-file-round/close-file-roind.icon';
import { useEffect, useMemo, useRef, useState } from 'react';
import { ObjectForm } from '@features/object-form';
import { stringToObject } from '@utils/data-helper';
import { getObjectEntity } from '@utils/form-object-helper';
import { IconConnection } from '@consta/icons/IconConnection';
import { IAttachmentComponentProps } from '../attachment-list.component';
import { TBaseObjectDto, TAttachment } from '@src/types';

export const Object = ({ onChange, attachment }: IAttachmentComponentProps) => {
    const [isShowModal, setIsShowModal] = useState<boolean>(false);
    const [isShowContext, setIsShowContext] = useState<boolean>(false);
    const object = useMemo<TBaseObjectDto>(() => stringToObject(attachment.link), [attachment]);
    const entity = useMemo(() => getObjectEntity(object.$type), [object]);
    const anchorRef = useRef<HTMLElement | null>(null);
    const currentFile = useRef<TAttachment | null>(null);

    useEffect(() => {
        if (!setIsShowContext) {
            currentFile.current = null;
        }
    }, [setIsShowContext]);

    const contextMenuItems = useMemo(
        () => [
            {
                label: 'Удалить',
                icon: <CloseFileRoundIcon className="hidden-buttons__button" />,
                onClick: () => {
                    currentFile.current && onChange(currentFile.current, 'delete');
                    setIsShowContext(false);
                }
            }
        ],
        []
    );

    const onKebabButtonClick = (e: React.MouseEvent<HTMLElement>) => {
        anchorRef.current = e.target as HTMLElement;
        setIsShowContext(true);
    };

    return (
        <>
            <IconConnection size="xs" view="brand" />

            <Text
                view="primary"
                size="m"
                className="attachment-list__file_name break-all text-[#045A9A] cursor-pointer hover:text-link-hover"
                onClick={() => setIsShowModal(true)}
            >
                {attachment.name}
            </Text>

            <div className="attachment-list__file_button h-full cursor-pointer">
                <IconKebab
                    size="xs"
                    view="brand"
                    onClick={(e) => {
                        onKebabButtonClick(e);
                        currentFile.current = attachment;
                    }}
                />
            </div>

            <ContextMenu
                items={contextMenuItems}
                isOpen={isShowContext}
                anchorRef={anchorRef}
                getItemLeftSide={(item) => item.icon}
                onClickOutside={() => setIsShowContext(false)}
                direction="downStartRight"
                style={{ pointerEvents: 'auto' }}
                className="absolute"
            />

            {isShowModal && (
                <ObjectForm
                    type={object.$type}
                    initialItem={object}
                    onClose={() => {
                        setIsShowModal(false);
                    }}
                    {...entity}
                />
            )}
        </>
    );
};
